/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const QuizCircledIcon = /*#__PURE__*/ createSvgIcon(
  'QuizCircledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <circle cx={10} cy={10} r={10} fill="#E8EEF7" />
            <path
              d="M4.9 15.5c-.33 0-.613-.117-.848-.352A1.156 1.156 0 013.7 14.3V5.5c0-.33.117-.612.352-.848.235-.234.518-.352.848-.352h10.4c.33 0 .612.118.848.353.235.235.352.517.352.847v8.8c0 .33-.117.612-.352.848a1.156 1.156 0 01-.848.352H4.9zm0-1.2h10.4V5.5H4.9v8.8zm3.317-1.183c.17 0 .312-.058.427-.172a.576.576 0 00.173-.425.587.587 0 00-.173-.428.576.576 0 00-.427-.175h-2a.582.582 0 00-.428.171.575.575 0 00-.172.425c0 .17.057.312.172.429a.577.577 0 00.428.175h2zM11.8 10.2l-.43-.435a.536.536 0 00-.416-.173.64.64 0 00-.429.191.596.596 0 00.005.847l.857.856c.12.12.258.18.416.18a.558.558 0 00.414-.183l2-2a.584.584 0 000-.85.586.586 0 00-.85 0L11.8 10.2zm-3.583.3c.17 0 .312-.057.427-.171a.575.575 0 00.173-.426.587.587 0 00-.173-.428.576.576 0 00-.427-.175h-2a.582.582 0 00-.428.171.575.575 0 00-.172.425c0 .17.057.312.172.429a.576.576 0 00.428.175h2zm0-2.6c.17 0 .312-.057.427-.171a.575.575 0 00.173-.426.587.587 0 00-.173-.428.576.576 0 00-.427-.175h-2a.582.582 0 00-.428.171.575.575 0 00-.172.425c0 .17.057.312.172.429a.576.576 0 00.428.175h2z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default QuizCircledIcon;
